import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (!AuthService.getUser().introCompleted && window.innerWidth > 820) {
                return next({ name: 'index.intro' })
            }
            next()
        })
    },
}
